import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
//  import { useSelector } from "react-redux";

const SidebarContent = (props) => {
  const ref = useRef();
  const user = JSON.parse(localStorage.getItem("user"))
  const groups =String(user.groups);


  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  const scrollElement = (item) => {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  };

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            <li>
              <Link to="/dashboard">
                <i className="bx bxs-dashboard"></i>
                <span key="t-dashboard">Dashboard</span>
              </Link>
            </li>
          { groups.includes("SuperAdmin") ||  groups.includes("Supervisor") ? (
           <> <li>
              <Link to="#">
                <i className="fas fa-users"></i>
                <span key="t-users">Usuarios</span>
              </Link>
               <ul className="sub-menu">
                <li><Link to="/users">Usuarios</Link></li>
                <li><Link to="/rol/add_rol">Roles</Link></li>
                <li><Link to="/rol/update_rol">Asignar Rol</Link></li>
                   
              </ul>
            </li>
          </>
          ):null }
        { groups.includes("SuperAdmin") ||  groups.includes("Supervisor") ||  groups.includes("Operador") ? (
           <li>
              <Link to="#">
                <i className=" fab fa-whmcs"></i>
                <span key="t-Parametrizaciones">Parametrizaciones</span>
              </Link>
              <ul className="sub-menu">
                {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") ?(
                  <>
                <li><Link to="/rol/agent_assign">Asignar Agentes</Link></li>
                <li><Link to="/account">Cuentas</Link></li>
                <li><Link to="/campaign">Campañas</Link></li>
                <li><Link to="/lengs">Prospectos</Link></li>


                </>
                ):null}

              </ul>
            </li>
            ):null }

               <li>
             <Link to="/contacts">
               <i className="fas fa-user-tie"></i>
               <span key="t-contacts">Contactos</span>
             </Link>
             <ul className="sub-menu">
                {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") ||  groups.includes("COMERCIAL") ?(
                  <>
                <li><Link to="/contacts">Contactos</Link></li>
                <li><Link to="/calendar">Calendario</Link></li>
                <li><Link to="/contact/add_grupoTecnico">Grupo Tecnicos</Link></li>
                <li><Link to="/contact/update_grupoTecnico">Asignar Contacto a Grupo </Link></li>
                <li><Link to="/leads">Pre-Contactos </Link></li>
              
                


                </>
                ):null}

              </ul>
           </li>
      
                

    
      
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
};

export default withRouter(withTranslation()(SidebarContent));
